export default __webpack_public_path__ + "static/media/Spotify.9c96b049.svg";